import {
  CompanyConfigDocument,
  VerifyAuthenticationDomainDocument,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useMutation } from 'modules/core/hooks/useMutation'

export function useVerifyAuthenticationDomain() {
  const [mutation, { loading }] = useMutation(VerifyAuthenticationDomainDocument, {
    extractorFn: (data) => data.authenticationMutations.verifyAuthenticationDomain,
  })

  const verifyAuthenticationDomain = useUnsafeCallback(
    (id: number) => {
      return mutation({
        variables: {
          id: id,
        },
        refetchQueries: [CompanyConfigDocument],
      })
    },
    [mutation]
  )

  return {
    verifyAuthenticationDomain,
    loading,
  }
}
